/**
 * Device-local memory of submissions this browser has created or opened.
 * Stores the code + business name + last-seen status ONLY — never the PIN.
 * Lets the agent home show quick "reopen" cards without caching any secret.
 */
export interface RecentSub {
  code: string;
  businessName?: string;
  status?: string;
  at: number;
}

const KEY = 'commpass:recent';

export function getRecent(): RecentSub[] {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(v) ? (v as RecentSub[]) : [];
  } catch {
    return [];
  }
}

export function addRecent(sub: { code: string; businessName?: string; status?: string }): void {
  if (!sub.code) return;
  try {
    const list = getRecent().filter((r) => r.code !== sub.code);
    list.unshift({ code: sub.code, businessName: sub.businessName, status: sub.status, at: Date.now() });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
  } catch {
    /* ignore storage failures */
  }
}

export function removeRecent(code: string): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(getRecent().filter((r) => r.code !== code)));
  } catch {
    /* ignore */
  }
}
